import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import env from "./env";
import { clearSession } from "./auth";

const AUTH_STORAGE_KEY = "access_token";

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: env.PLATFORM_URL_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    try {
      const accessToken = localStorage.getItem(AUTH_STORAGE_KEY);
      if (!accessToken) {
        return config;
      }

      const newConfig = { ...config };
      newConfig.headers.Authorization = `Bearer ${accessToken}`;

      return newConfig;
    } catch {
      return config;
    }
  }
);

// Response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error is an authentication error (401)
    if (error.response?.status === 401) {
      console.warn("Authentication failed - redirecting to login");
      clearSession(); // This clears localStorage and redirects to /login
    }
    return Promise.reject(error);
  }
);
